import React from 'react';
import { useOrganizationStore } from '../../store/organization.store';
import './OrgLogoChip.scss';

interface Props {
  size?: number;
  className?: string;
  /** Override the URL/name from the store (e.g. for previews on the Branding tab). */
  overrideUrl?: string | null;
  overrideName?: string | null;
}

const getInitials = (name: string | null | undefined): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const OrgLogoChip: React.FC<Props> = ({ size = 40, className, overrideUrl, overrideName }) => {
  const storeLogoUrl = useOrganizationStore((s) => s.currentOrgLogoUrl);
  const storeName = useOrganizationStore((s) => s.currentOrgName);

  const logoUrl = overrideUrl !== undefined ? overrideUrl : storeLogoUrl;
  const name = overrideName !== undefined ? overrideName : storeName;

  return (
    <div
      className={`org-logo-chip${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-label={name || undefined}
      role="img"
    >
      {logoUrl ? (
        <img src={logoUrl} alt={name ? `${name} logo` : 'Organization logo'} />
      ) : (
        <span className="org-logo-chip__initials" style={{ fontSize: size * 0.38 }}>
          {getInitials(name)}
        </span>
      )}
    </div>
  );
};

export default OrgLogoChip;
